import { render, staticRenderFns } from "./nosearch.vue?vue&type=template&id=538df243&"
import script from "./nosearch.vue?vue&type=script&lang=js&"
export * from "./nosearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports